import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/our-work/digital-circuits/page.tsx");
